$(document).ready(() => {
  $('.toggle-password').click(function(){
    $(this).children().toggleClass('d-none');
    let input = $(this).prev();
    input.attr('type', input.attr('type') === 'password' ? 'text' : 'password');
  });
});
